import routes from '@/config/routes';
import { v3Get, v3Put, v3Remove } from '../axios.instance.V3';
import { ApiResponse } from '../types';

const editApplication = (applicationId: number, currentStatusId: number): ApiResponse => {
  return v3Put(`${routes.backendUrl.gigApplication.editApplication}/${applicationId}/${currentStatusId}`);
};

const deleteApplication = (applicationId: number, currentStatusId: number): ApiResponse => {
  return v3Remove(`${routes.backendUrl.gigApplication.deleteApplication}/${applicationId}/${currentStatusId}`);
};

const getApplicationContext = (applicationId: string): ApiResponse => {
  return v3Get(`${routes.backendUrl.application.context}${applicationId}/context`);
};

export const applicationApis = {
  editApplication,
  deleteApplication,
  getApplicationContext,
};
